'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.OVERENY = exports.NEOVERENY = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:41:39Z                      #

// ##############################################################

/**
 * Typ důvěryhodnoti účtu, vyhodnocovaný typ, který se určí na základě různých okolností a definuje, zda lze danému účtu "věřit" - že je to opravdu on.
 */

/**
 * Neověřený účet - není jisté, zda je důvěryhodný - zda je daná osoba skutečně danou osobou.
 */
var NEOVERENY = exports.NEOVERENY = 'NEOVERENY';

/**
 * Ověřený účet - lze mu "věřit".
 */
var OVERENY = exports.OVERENY = 'OVERENY';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [NEOVERENY, OVERENY];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, NEOVERENY, { caption: 'Neověřený účet - není jisté, zda je důvěryhodný - zda je daná osoba skutečně danou osobou.' }), (0, _defineProperty3.default)(_params, OVERENY, { caption: 'Ověřený účet - lze mu "věřit".' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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